import React, { useState, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AUTH_LOGOUT } from 'actions/auth';
import { INITIAL_SYNC_PRODUCTS } from 'actions/sync-products';
import { INITIATE_STORES } from 'actions/stores';
import ShoppingCart from '@material-ui/icons/ShoppingCart';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Button from 'components/Button';
import Drawer from 'components/Drawer';
import CountryModal from 'components/Header/CountryModal';
import COLORS from 'shared/constants/colors';
import USAFlag from 'assets/images/usa-flag.png';
import CADFlag from 'assets/images/canada-flag.png';
import LogoImage from 'assets/images/logo.png';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';

import {
  Nav,
  Wrapper,
  Logo,
  Bars,
  Menu,
  CurrencyFlag,
  UserName,
  menuItemsRightMargin,
  CurrencyMenu,
  MobileMenu,
} from 'styles/components/Header';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      padding: '6px',
    },
  },
}));

const Header = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [countryModalVisibility, updateCountryModalVisibility] =
    useState(false);
  const [drawerVisibility, updateDrawerVisibility] = useState(false);
  const toggleCountryModal = () =>
    updateCountryModalVisibility(!countryModalVisibility);
  const toggleDrawer = () => updateDrawerVisibility(!drawerVisibility);
  const profile = useSelector((state) => state?.auth?.profile);
  const currency = useSelector((state) => state?.currency?.value);

  return (
    <Fragment>
      <Nav>
        <Wrapper>
          <Bars onClick={toggleDrawer} />
          <Logo className="logo" src={LogoImage} alt="logo" />
        </Wrapper>
        <Wrapper>
          <Menu>
            <UserName>Hello {profile?.FullName}</UserName>
            <Button
              containerStyle={{
                marginRight: `${menuItemsRightMargin}px`,
                color: COLORS.GREY,
                textTransform: 'capitalize',
                color: '#fff',
              }}
              startIcon={<ExitToAppIcon />}
              variant="text"
              title="Logout"
              onClick={() => {
                dispatch({ type: INITIATE_STORES });
                dispatch({ type: AUTH_LOGOUT });
                dispatch({ type: INITIAL_SYNC_PRODUCTS });
              }}
            />
            <CurrencyMenu>
              Currency:
              <CurrencyFlag
                src={currency === 'USD' ? USAFlag : CADFlag}
                alt="currency"
                onClick={toggleCountryModal}
              />
            </CurrencyMenu>
          </Menu>
          <MobileMenu>
            <UserName>Hello {profile?.FullName}</UserName>
            <div className={classes.root}>
              <IconButton aria-label="delete">
                <ExitToAppIcon />
              </IconButton>
            </div>

            <CurrencyMenu>
              <CurrencyFlag
                src={currency === 'USD' ? USAFlag : CADFlag}
                alt="currency"
                onClick={toggleCountryModal}
              />
            </CurrencyMenu>
          </MobileMenu>
        </Wrapper>
      </Nav>
      {countryModalVisibility && (
        <CountryModal
          open={countryModalVisibility}
          onClose={toggleCountryModal}
        />
      )}

      {drawerVisibility && (
        <Drawer open={drawerVisibility} toggle={toggleDrawer} />
      )}
    </Fragment>
  );
};

export default Header;
